export default {"src":"/_next/static/media/ethereum.93fc33c8.svg","height":417,"width":256,"blurWidth":0,"blurHeight":0};